@if (iframeUrl) {
  <iframe class="metabase-iframe" [src]="iframeUrl"></iframe>
}
